<app-header></app-header>
<section class="container-xxl ">
    <div class="breadcrumb-area">
        <!-- <app-plugin-breadcrumb [datacollection]="{data:P_data,'showEmpMen':showEmpMen,'emp_dtl':emp_dtl}" *ngIf="showBarComponent"></app-plugin-breadcrumb> -->

        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a class="screen-reader" routerLink="/" [attr.title]="language=='English'?'Home':'होम'">{{ 'Home' | translate }}</a></li>
            
            <li class="breadcrumb-item"><a class="active-nemu screen-reader"
                    routerLink="/videoCategoryarchive">{{'ArchiveVideocategory' | translate}}</a></li>
        </ol>

    </div>
    <div class="inner-page-sidedetails">
        <div id="section-New"></div>
        <div class="inner-banner-image">
            <div class="image-area">
                <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
            </div>
        </div>
        <div class="details"> 
            <div class="title d-flex justify-content-between">
                <h2 class="screen-reader">{{'ArchiveVideocategory' | translate}} </h2>
                <a routerLink="/videocategory" [attr.title]="language=='English'?'Video Category':'वीडियो श्रेणी'" href="javascript:void(0);" class="btn btn-sm btn-outline-success screen-reader"><i class="bi bi-archive me-2"></i>{{'videocategory' | translate}}</a>
            </div>
            <div class="description">
                <div class="gallery-category mt-3 mb-5">
                    <p class="text-center" *ngIf="photoprogress"><i class="spinner-border spinner-border-sm text-bark" style="font-size: large;" aria-hidden="true"></i></p>
                    <div class="row grid grid-cols-1 sm:grid-cols-6 gap-6 md:gap-8" *ngIf="photoprogress==false && galleryCat.length > 0">
                        <div class="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12" *ngFor="let item of galleryCat">
                            <div class="gallery-category-sec">
                                <div class="gallery-category-image">
                                    <img  [src]="this.imageUrl+item.featuredImage" alt="Category Image" class="img-fluid screen-reader">
                                </div>
        
                                <div class="gallery-category-text">
                                    <div class="d-flex align-items-center justify-content-between mb-3">
                                        <div class="ms-1 me-3 screen-reader" *ngIf="item.photolength > 0  else elseBlocks">
                                            <a [attr.title]="language=='English'?'View Videos':'वीडियो देखें'" class="text-green font-adjust" (click)="viewDetails(item.id,'archivevideogallery')"  href="javascript:void(0);" > 
                                                <i class="bi bi-camera-reels"></i> {{ item.photolength}} {{'Videos'| translate}} 
                                                </a>
                                        </div>
                                         <ng-template #elseBlocks>
                                      <div class="ms-1 me-3 screen-reader">
                                            <a [attr.title]="language=='English'?'View Videos':'वीडियो देखें'" class="text-green font-adjust" href="javascript:void(0);" > 
                                                <i class="bi bi-camera-reels"></i> 0 {{'Videos'| translate}} 
                                                </a>
                                        </div>
                                    </ng-template>
                                    </div>
                                    <h5 class="fw-bold screen-reader">{{htmldecode(language == 'English' ? item.category: item.categoryInHindi)}}</h5>
                                    <p class="shot-des font-adjust screen-reader">{{(language == 'English' ? item.shortDescription: item.shortDescriptionInHindi)}}</p>
                                    <div class="d-flex align-items-center" *ngIf="item.photolength > 0 ">
                                        <div class="screen-reader">
                                            <a [attr.title]="language=='English'?'View Album':'एल्बम देखें'" class="text-green"  (click)="viewDetails(item.id,'archivevideogallery')"  href="javascript:void(0);"> 
                                                <i class="bi-eye"></i> {{'ViewAlbum' | translate}}  
                                                </a>                                              
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>
                    <p class="text-center font-adjust screen-reader" *ngIf="photoprogress==false && galleryCat.length <= 0">{{ "Norecordsfound" | translate }}</p>
                </div>
            </div>

        </div>
    </div>
</section>

<app-clients></app-clients>

<app-footer></app-footer>
